
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/casos/zignet",
      function () {
        return require("private-next-pages/[locale]/casos/zignet.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/casos/zignet"])
      });
    }
  